module.exports = __webpack_public_path__ + "static/media/dashboard-soon.c0374e67.svg";